// getUserMedia が権限拒否で reject する際の「想定内エラー」を判定する。
// getUserMedia は DOMException(NotAllowedError)を投げるが、DOMException は環境
// (iOS WebView / LINE 内ブラウザなど)によって Error のサブクラスにならず
// `instanceof Error` が false になるため、name を防御的に読み取って判定する。
const PERMISSION_DENIED_ERROR_NAMES = new Set([
  // 権限拒否 / dismissed / "request is not allowed" はすべて同一 name
  "NotAllowedError",
  // 旧仕様・一部 SDK で使われる name
  "PermissionDeniedError",
]);

export const isMediaPermissionDeniedError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) return false;

  const name = (error as { name?: unknown }).name;

  return typeof name === "string" && PERMISSION_DENIED_ERROR_NAMES.has(name);
};
